import { render, staticRenderFns } from "./titleheader.vue?vue&type=template&id=0b7cfe72&scoped=true"
import script from "./titleheader.vue?vue&type=script&lang=js"
export * from "./titleheader.vue?vue&type=script&lang=js"
import style0 from "./titleheader.vue?vue&type=style&index=0&id=0b7cfe72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7cfe72",
  null
  
)

export default component.exports